module.exports = __webpack_public_path__ + "img/logo-hello.be23ce16.png";